export default function getRatePercentage(value, total) {
  let percentage = 0;
  if (value && total) {
    percentage = ((value * 100) / total).toFixed(1);
  }

  return `${percentage}%`;
}
